import { logDatapoint as logDatapointCore } from "owa-analytics-core/lib/loggingFunctions/logDatapoint";
import type { LogDatapointParams } from "owa-analytics-types";
import { getAnalyticsAddon } from "owa-analytics-addons";
import { getThreadName } from "owa-thread-config";
import { queueOrRun } from "owa-analytics-utils";
import { logToTracingPanel } from "../../utils/logToTracingPanel";
import { getAnalyticsFlightsAndAppSettings } from "owa-analytics-core/lib/settings/getAnalyticsFlightsAndAppSettings";
import { isRunningOnWorker } from "owa-config";
import { enrichDatapointWithAppVisibility } from "owa-analytics-core";

export function logDatapoint(...[datapoint, overrideEventType]: LogDatapointParams): void {
    logToTracingPanel(datapoint);
    enrichDatapointWithAppVisibility(datapoint);
    
    queueOrRun<LogDatapointParams>("logDatapoint", logDatapointFunction, datapoint, overrideEventType);
}

export function logDatapointFunction(...[datapoint, overrideEventType]: LogDatapointParams): void {
    if (getThreadName() === "MAIN_THREAD") {
        getAnalyticsAddon("LogInWorkerOrMainThread")?.executeWhenReady(logDatapointCore, "logDatapoint", datapoint, overrideEventType);
    }
    else {
        logDatapointCore(datapoint, overrideEventType);
    }
    
    if (!isRunningOnWorker() && getAnalyticsFlightsAndAppSettings()?.devToolsEnabled) {
        getAnalyticsAddon("LogUnifiedTelemetryDiagnostics")?.executeWhenReady(datapoint);
    }
}
